import { connect } from 'react-redux';

import SearchResults from './SearchResults';
import {
    trackDoctorCardClick,
    trackSearchScrollCount,
    trackScrolledToSearchResult,
    trackTimesgridClickNext,
    trackTimesgridClickPrev,
    trackTimesgridClickTime,
    trackTimesgridClickMoreTimes,
    trackTimesgridClickNextAvailable,
    trackTimesgridClickPhoneNumber,
    trackTimesgridLoaded,
    trackTimesgridDataLoaded,
} from '../../../actions';

import {
    getInsuranceCarrierId,
    getInsurancePlanId,
    getSearchParameters,
} from '../../../state';

import {
    getAvailabilityTimeFilter,
    getAvailabilityTimeFilterForFacetedSearch,
} from '../../../utils/get-availability-time-filter';

import { mockable } from '../../../../config/mockable';

const mapStateToProps = (state, ownProps) => {
    const {
        filters,
        showTimesAfter5,
        showTimesBefore10,
    } = getSearchParameters(state);

    const { shouldRenderFacetedSearchBar, facets } = ownProps;

    const availabilityTimeFilter = shouldRenderFacetedSearchBar
        ? getAvailabilityTimeFilterForFacetedSearch(filters, facets)
        : getAvailabilityTimeFilter(showTimesBefore10, showTimesAfter5);

    return {
        availabilityTimeFilter,
        insuranceCarrierId: getInsuranceCarrierId(state),
        insurancePlanId: getInsurancePlanId(state),
    };
};

const mapDispatchToProps = {
    trackDoctorCardClick,
    trackScrolledToSearchResult,
    trackSearchScrollCount,
    trackTimesgridClickNext,
    trackTimesgridClickPrev,
    trackTimesgridClickTime,
    trackTimesgridClickMoreTimes,
    trackTimesgridClickNextAvailable,
    trackTimesgridClickPhoneNumber,
    trackTimesgridLoaded,
    trackTimesgridDataLoaded,
};

const SearchResultsConnected = connect(mapStateToProps, mapDispatchToProps)(SearchResults);

const searchResultsResolver = () => SearchResultsConnected;

const SearchResultsMockable = mockable(searchResultsResolver);

export {
    searchResultsResolver,
    SearchResultsMockable as default,
};
